import { Group, Select, Stack, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { httpPostGraphql } from "shared/api/httpClient";
import { useIpawsAlertFormContext } from "shared/components/ipaws/alert/context";
import { useFormState } from "shared/hooks/useFormState";
import { usePermissions } from "shared/stores/oidc";
import { graphql } from "src/gql";
import { Permission } from "src/gql/graphql";

export const IpawsAlertFormProfileCertificateSelect = (props: { widget?: boolean }) => {
    const form = useIpawsAlertFormContext();
    const [certId, setCertId] = useFormState(form, "certId");
    const { permissions } = usePermissions();

    const certs = useSuspenseQuery(query.certificates());

    const certsWithPermissions = certs.data.ipawsCertificates.filter((cert) =>
        permissions.ipaws.some((ipawsPerm) => ipawsPerm.id == cert.id && ipawsPerm.permissions.includes(Permission.IpawsAlertModify)),
    );

    return (
        <Select
            label="IPAWS Profile"
            required
            searchable
            disabled={!!props.widget}
            data={certsWithPermissions.filter((cert) => cert.enabled).map(({ id, name }) => ({ label: name, value: id }))}
            renderOption={(cert) => (
                <Group flex="1" gap="xs" justify="flex-start">
                    {cert.checked && <IconCheck size={16} />}
                    <Stack gap={0}>
                        <Text fz="sm">{cert.option.label}</Text>
                        <Text size="xs">{certsWithPermissions.find((c) => c.id == cert.option.value)!.type}</Text>
                    </Stack>
                </Group>
            )}
            value={certId}
            onChange={(_, { value }) => setCertId(value)}
            error={form.getInputProps("certId").error}
        />
    );
};

const query = {
    certificates: () =>
        queryOptions({
            queryKey: ["ipaws-alert-form-profile-certificate-select"],
            queryFn: () =>
                httpPostGraphql(
                    graphql(`
                        query IpawsAlertFormProfileCertificateSelect {
                            ipawsCertificates {
                                id
                                name
                                enabled
                                type
                            }
                        }
                    `),
                ),
        }),
};
